import React from "react";
import { BreadCrumbLabel, BreadcrumbrumbText, BreadCrumbWrapper, EllipsisWrapper, TooltipItem, BreadcrumbSeparator } from "./BreadCrumbStyled";
import { Tooltip } from "antd";
import { CaretRight } from "@phosphor-icons/react";
import PropTypes from 'prop-types';
import Ellipses from '../../assets/images/ellipses.svg'

const Breadcrumb = ({ breadcrumb, onBreadcrumbClick }) => {
  const shouldTruncate = breadcrumb?.length > 5;

  const visibleBreadcrumb = shouldTruncate
    ? [
        breadcrumb[0], // root
        'ellipsis',
        ...breadcrumb.slice(-3) // last 3
      ]
    : breadcrumb;

  const hiddenBreadcrumb = shouldTruncate
    ? breadcrumb.slice(1, -3) // middle folders
    : [];

  return (
    <BreadCrumbWrapper>
      {visibleBreadcrumb?.map((folder, index) => {
        if (folder === 'ellipsis') {
          return (
            <Tooltip
              key="ellipsis"
              placement="bottomLeft"
              color="white"
              title={
                <EllipsisWrapper>
                  {hiddenBreadcrumb.map((hiddenFolder, hiddenIndex) => {
                    const actualIndex = breadcrumb.indexOf(hiddenFolder);
                    const isLast = actualIndex === breadcrumb.length - 1;
                    const isClickable = !isLast;
                    
                    return (
                      <TooltipItem
                        key={hiddenFolder.id}
                        onClick={isClickable ? () => onBreadcrumbClick(hiddenFolder.id, actualIndex) : undefined}
                        style={{ cursor: isClickable ? 'pointer' : 'default', opacity: isClickable ? 1 : 0.5 }}
                      >
                        {hiddenFolder.name}
                      </TooltipItem>
                    );
                  })}
                </EllipsisWrapper>
              }
            >
              <BreadCrumbLabel><img src={Ellipses} alt="Eclipse"/><BreadcrumbSeparator><CaretRight size={10} weight="bold" /></BreadcrumbSeparator></BreadCrumbLabel>
            </Tooltip>
          );
        }

        const isLast = index === visibleBreadcrumb.length - 1;
        const actualIndex = breadcrumb.indexOf(folder);
        // The MATTER crumb (index 1) stays clickable even when it's last:
        // legacy folders can lose their folder crumb, collapsing the trail
        // to [Matters, matter] — without this, there was no way back to
        // the matter root (Matthew, 2026-07-22). The click handler no-ops
        // when the user is already at the root.
        const isClickable = !isLast || (actualIndex === 1 && folder?.id !== 0);
        
        return (
          <BreadCrumbLabel
            key={folder.id}
            onClick={isClickable ? () => onBreadcrumbClick(folder.id, actualIndex) : undefined}
            className={isLast ? "active" : ""}
            style={{ cursor: isClickable ? 'pointer' : 'default' }}
          >
            <Tooltip placement="bottom" title={folder.name}>
              <BreadcrumbrumbText 
                className={isLast ? "active" : ""}
                style={{ cursor: isClickable ? 'pointer' : 'default' }}
              >
                {folder.name}
              </BreadcrumbrumbText>
            </Tooltip>
            {!isLast && <BreadcrumbSeparator><CaretRight size={10} weight="bold" /></BreadcrumbSeparator>}
          </BreadCrumbLabel>
        );
      })}
    </BreadCrumbWrapper>
  );
};

Breadcrumb.propTypes = {
  breadcrumb: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  onBreadcrumbClick: PropTypes.func.isRequired,
};

export default Breadcrumb;

